module.exports = __webpack_public_path__ + "static/media/inf_43og55.9a96c2f9.mp3";